// extracted by mini-css-extract-plugin
export default {"statistic":"styles_statistic__WDdUU","progress":"styles_progress__dzerF","progress_item":"styles_progress_item__EPVeq"};